import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import Anchor from "../elements/Anchor";

import "../../styles/components/slices/specs.scss";

const Specs = ({ slice }) => {
  if (!slice) return null;
  const {
    main_title,
    background_image,
    btn_label,
    btn_link,
    info_boxes,
    info_text,
    subtitle1,
  } = slice.primary;

  return (
    <Container
      fluid
      className="specs_section mb-5"
      style={{
        backgroundImage: background_image?.gatsbyImageData
          ? `url(${background_image.gatsbyImageData.images.fallback.src})`
          : null,
        backgroundSize: "cover",
      }}
    >
      <Container className=" max-container">
        <Row className="justify-content-center text-center">
          <h1 className="fw-light mb-5">{main_title.text}</h1>
          <div className="text-start mb-md-5">
            <PrismicRichText field={subtitle1.richText} />
          </div>
        </Row>
        <Row className="gap-4">
          {slice.items.map((item) => (
            <Col key={item.category} className="categories">
              <div className="d-flex align-items-baseline me-5 mb-4">
                <GatsbyImage
                  image={item.icon.gatsbyImageData}
                  alt={item.icon.alt || "social"}
                  style={{ maxHeight: "54px" }}
                />
                <p className="cat-name fw-bold ms-3 mb-0">{item.category}</p>
              </div>

              <PrismicRichText field={item.description.richText} />
            </Col>
          ))}
          <PrismicRichText field={info_text.richText} />
        </Row>
        <Row className="wrapper-box">
          <PrismicRichText field={info_boxes.richText} />
        </Row>
        <Row>
          <div className="book-now-outline mona mx-auto">
            <Anchor
              href={btn_link.url}
              target={btn_link.target}
              className="book-now-btn"
            >
              {btn_label}
            </Anchor>
          </div>
        </Row>
      </Container>
    </Container>
  );
};

export default Specs;
